import { connectRouter } from 'connected-react-router';
import withDependencies from '@factorin/container.macro';

import { routerMiddleware } from './middleware';


export const isSagaObject = obj => obj['@@redux-saga/IO'];

export const state = {
    reducer: {
        router: withDependencies(history => connectRouter(history)),
    },
    sagas: [],
    middleware: [
        routerMiddleware,
    ],
};
